<template>
   <div>
    <el-dialog :show-close="false" :visible="dialogVisibleState" :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
      :width="'620px'" >
      <template #title>
        <div class="dialog-title-box">
          <span>{{$t('message.subscription.editSubsInfo')}}</span>
          <rhcn-button
            class="icon-button dialog-close-icon"
            size="small"
            @click="dialogVisibleState = false"
          ><i class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <validation-component
        ref="validationFormRefState"
        inputWidth="500px"
        labelWidth="150px"
        :validation-condition="validationCondition"
      >
        <template slot="billingFrequency">
          <el-form-item prop="billingFrequency" :rules="{
            validator: validateFunction
          }">
            <div style="display: flex;align-items: center;">
              <el-input :disabled="!isEqualState" style="width: 200px;margin-right: 20px;" v-model="submitParamState.frequencyPoint"></el-input>
              <el-select :disabled="!isEqualState" v-model="submitParamState.frequencyType">
                <el-option :label="$t('message.common.dateOptions.D')" value="D"></el-option>
                <el-option :label="$t('message.common.dateOptions.W')" value="W"></el-option>
                <el-option :label="$t('message.common.dateOptions.M')" value="M"></el-option>
                <el-option :label="$t('message.common.dateOptions.Y')" value="Y"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </template>
      </validation-component>
      <template #footer>
        <div class="dialog-footer">
          <el-button style="width: 100%;" v-if="isEqualState" type="primary" @click="submitClick" >保存</el-button>
          <!-- 当修改了表单的值时 -->
          <div v-if="!isEqualState" style="display: flex;flex-direction: column;width: 100%;">
            <div class="info" >{{ $t('message.subscription.changeInfoText') }}</div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <el-button style="flex: 1;" @click="isEqualState = true" >上一步</el-button>
              <el-button style="flex: 1;" type="primary" @click="save" :loading="btnLoadingState" >确认</el-button>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import RhcnButton from '@/components/form/button.vue';
import { ShowSuccessMessage, ShowWarningMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips.js';
import { REQUIRED, AMOUNT, NUMBER, VALIDATE_NUMBER_1_100, STRING_LENGTH_50, AMOUNT_WITH_MINUS } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { enantiomericValues, getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { shallowClones } from '@/utils/tools/utils';
import { updateSubscriptionDetail } from '@/views/subscription/api/subscription';

export default {
  name: 'EditDialog',
  components: {
    RhcnButton,
    ValidationComponent,
  },
  data() {
    return {
      dialogVisibleState: false,
      btnLoadingState: false,
      originSubmitParamState: {},
      submitParamState: {},
      paymentMethodList: [],
      isEqualState: true,
      validationCondition: [
        {
          key: 'collectionMethod',
          name: 'message.subscription.collectionMethod',
          type: 'input',
          defValue: '',
          isDisabled: true,
          placeholder: ' ',
          isShowStar: true,
        },
        {
          key: 'website',
          name: 'message.subscription.transactionUrl',
          type: 'input',
          defValue: '',
          isDisabled: true,
          placeholder: ' ',
          isShowStar: true,
        },
        {
          key: 'trialEnd',
          name: 'message.subscription.trailEndDate',
          type: 'input',
          defValue: '',
          // rule: [REQUIRED],
          isDisabled: true,
          placeholder: ' ',
          isShowStar: true,
        },
        {
          key: 'createDate',
          name: 'message.subscription.createDate',
          type: 'input',
          defValue: '',
          isDisabled: true,
          placeholder: ' ',
          isShowStar: true,
        },
        {
          key: 'expireDate',
          name: 'message.subscription.expireDate',
          type: 'date_time',
          defValue: '',
          dateFormat: 'yyyy-MM-dd',
          dateValueFormat: 'yyyy-MM-dd',
          changeValue: (value) => {
            this.submitParamState.expireDate = value;
          },
        },
        {
          key: 'productName',
          name: 'message.subscription.productName',
          type: 'input',
          defValue: '',
          rule: [REQUIRED, STRING_LENGTH_50],
          isShowStar: true,
          changeValue: (value) => {
            this.submitParamState.productName = value;
          },
        },
        {
          key: 'productPrice',
          name: 'message.subscription.productPrice',
          type: 'input',
          defValue: '',
          rule: [],
          validator: (rule, value, callback) => {
            if (value && !AMOUNT.regExp.test(value)) {
              callback(new Error(this.$t(AMOUNT.tips)));
            }
            callback();
          },
          changeValue: (value) => {
            this.submitParamState.productPrice = value;
          },
        },
        {
          key: 'productCount',
          name: 'message.subscription.productCount',
          type: 'input',
          defValue: '',
          rule: [],
          validator: (rule, value, callback) => {
            if (value && !NUMBER.regExp.test(value)) {
              callback(new Error(this.$t(NUMBER.tips)));
            }
            callback();
          },
          changeValue: (value) => {
            this.submitParamState.productCount = value;
          },
        },
        {
          key: 'cycleCount',
          name: 'message.subscription.cycleCount',
          type: 'input',
          defValue: '',
          rule: [],
          validator: (rule, value, callback) => {
            if (value && !VALIDATE_NUMBER_1_100.regExp.test(value)) {
              callback(new Error(this.$t(VALIDATE_NUMBER_1_100.tips)));
            }
            callback();
          },
          changeValue: (value) => {
            this.submitParamState.cycleCount = value;
          },
        },
        // 扣款金额
        {
          key: 'orderAmount',
          name: 'message.subscription.orderAmount',
          type: 'input',
          defValue: '',
          rule: [AMOUNT],
          isShowStar: true,
          changeValue: (value) => {
            this.submitParamState.orderAmount = value;
          },
        },
        {
          key: 'billingFrequency',
          name: 'message.subscription.billingFrequency',
          type: 'slot',
          rule: [],
          isShowStar: true,
        },
        {
          key: 'proration',
          name: 'message.subscription.proration',
          type: 'input',
          defValue: '',
          rule: [],
          tipList: [
            { value: this.$t('message.subscription.prorationTip') },
            { value: this.$t('message.subscription.prorationTip1') },
            { value: this.$t('message.subscription.prorationTip2') },
            { value: this.$t('message.subscription.prorationTip3') },
          ],
          validator: (rule, value, callback) => {
            if (value && !AMOUNT_WITH_MINUS.regExp.test(value)) {
              callback(new Error(this.$t(AMOUNT_WITH_MINUS.tips)));
            }
            callback();
          },
          isHide: true,
          changeValue: (value) => {
            this.submitParamState.proration = value;
          },
        },
      ],
    };
  },
  methods: {
    validateFunction(rule, value, callback) {
      if (!this.submitParamState.frequencyPoint || !this.submitParamState.frequencyPoint) {
        callback(new Error(this.$t(REQUIRED.tips)));
      }

      if (!NUMBER.regExp.test(this.submitParamState.frequencyPoint)) {
        callback(new Error(this.$t(NUMBER.tips)));
      }
      callback();
    },
    open(data, _paymentMethodList) {
      this.dialogVisibleState = true;
      this.isEqualState = true;
      this.originSubmitParamState = shallowClones(data);
      this.submitParamState = shallowClones(data);
      this.paymentMethodList = _paymentMethodList;
    },
    close() {
      this.dialogVisibleState = false;
    },
    async submitClick() {
      this.$refs.validationFormRefState.toFormValid(async (param) => {
        if (this.submitParamState.orderAmount > 999999999999999) {
          ShowWarningMessage(this.$t('message.subscription.hugeMoneyTip'));
          return;
        }
        this.isEqualState = this.isObjectPartialDeepEqual(this.submitParamState, this.originSubmitParamState);
        // 无误的话 直接提交
        if (this.isEqualState) {
          this.close();
        }
      });
    },
    isObjectPartialDeepEqual(obj1, obj2) {
      // 如果两者引用同一个地址，直接返回 true
      if (obj1 === obj2) return true;

      // 如果其中一个不是对象或者是 null，则返回 false
      if (
        typeof obj1 !== 'object' ||
          obj1 === null ||
          typeof obj2 !== 'object' ||
          obj2 === null
      ) {
        return false;
      }

      // 获取第一个对象的所有 keys
      const keys1 = Object.keys(obj1);

      // 遍历 keys1 检查 obj2 是否有对应的值且相等
      for (const key of keys1) {
        // 如果 obj2 没有相同的 key，直接返回 false
        if (!Object.prototype.hasOwnProperty.call(obj2, key)) return false;

        // 递归比较子属性，类型断言 obj1 和 obj2 是 Record 类型以便访问 key
        const val1 = (obj1)[key];
        const val2 = (obj2)[key];
        if (!this.isObjectPartialDeepEqual(val1, val2)) return false;
      }

      return true;
    },
    async save() {
      try {
        this.btnLoadingState = true;
        const res = await updateSubscriptionDetail(this.submitParamState);
        this.btnLoadingState = false;
        if (res) {
          this.close();
          ShowSuccessMessage(this.$t('message.operateSuccessfulTip'));
          this.$emit('success');
        }
      } catch (error) {
        // 到期日期超出限制
        if (error.respCode === '00019|50026') {
          ShowErrorMessage(this.$t('message.subscription.expireDateErrorTips'));
        }
        this.btnLoadingState = false;
      }
    },
  },
  watch: {
    isEqualState(val) {
      // 如果有改动 需要提交 把表单禁用
      if (!val) {
        this.$refs.validationFormRefState.setItemHide('proration', false);
        this.$refs.validationFormRefState.setItemDisabled('expireDate', true);
        this.$refs.validationFormRefState.setItemDisabled('productName', true);
        this.$refs.validationFormRefState.setItemDisabled('orderAmount', true);
        this.$refs.validationFormRefState.setItemDisabled('productPrice', true);
        this.$refs.validationFormRefState.setItemDisabled('productCount', true);
        this.$refs.validationFormRefState.setItemDisabled('cycleCount', true);
      } else {
        this.$refs.validationFormRefState.setItemHide('proration', true);
        this.$refs.validationFormRefState.setItemDisabled('expireDate', false);
        this.$refs.validationFormRefState.setItemDisabled('productName', false);
        this.$refs.validationFormRefState.setItemDisabled('orderAmount', false);
        this.$refs.validationFormRefState.setItemDisabled('productPrice', false);
        this.$refs.validationFormRefState.setItemDisabled('productCount', false);
        this.$refs.validationFormRefState.setItemDisabled('cycleCount', false);
      }
    },
  },
  updated() {
    if (this.$refs.validationFormRefState) {
      this.$refs.validationFormRefState.setItemValue('collectionMethod', getEnantiomericValue(this.paymentMethodList, this.submitParamState.selfExecute));
      this.$refs.validationFormRefState.setItemValue('website', this.submitParamState.website);
      this.$refs.validationFormRefState.setItemValue('trialEnd', this.submitParamState.trialEnd);
      this.$refs.validationFormRefState.setItemValue('createDate', this.submitParamState.createDate);
      this.$refs.validationFormRefState.setItemValue('expireDate', this.submitParamState.expireDate);
      this.$refs.validationFormRefState.setItemValue('productPrice', this.submitParamState.productPrice);
      this.$refs.validationFormRefState.setItemValue('productCount', this.submitParamState.productCount);
      this.$refs.validationFormRefState.setItemValue('cycleCount', this.submitParamState.cycleCount);
      this.$refs.validationFormRefState.setItemValue('productName', this.submitParamState?.productName);
      this.$refs.validationFormRefState.setItemValue('orderAmount', this.submitParamState.orderAmount);
      // （如果没有扣款金额原值则取值单价×数量）
      const { orderAmount, productPrice, productCount } = this.submitParamState;
      if (!orderAmount && productPrice && productCount) {
        this.submitParamState.orderAmount = this.submitParamState.productPrice * this.submitParamState.productCount;
        this.$refs.validationFormRefState.setItemValue('orderAmount', this.submitParamState.orderAmount);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input-number .el-input__inner) {
  padding: 0.3rem;
}

:deep(.el-input-number__decrease) {
  display: none;
}

:deep(.el-input-number__increase) {
  display: none;
}

.info {
  font-family: OPPOSans, OPPOSans;
  font-weight: 400;
  font-size: 14px;
  color: #F97066;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 10px;
}
.dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .dialog-close-icon {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }

      .el-icon-close {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
</style>
